import { i18n } from '@legacy/js/plugin/vue-i18n.js';

export function useI18n() {
    return {
        i18n
    };
}
